import { React, useEffect } from 'react';
import {
  Button,
  Form,
  Select,
  Modal,
  DatePicker,
  Row,
  Col,
  message,
} from 'antd';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

const { RangePicker } = DatePicker;

// 進階篩選Modal
const ExtraSearch = (props) => {
  const {
    form,
    setFilters,
    filters,
    filterVisible,
    setFilterVisible,
    setLogData,
    fetchLogData,
    userInfo,
    originLogData,
  } = props;

  // 進階篩選
  const handleAdvancedFilter = async (values) => {
    let filtered = [...originLogData];

    // 操作時間篩選
    if (values.operationDate && values.operationDate.length === 2) {
      const [startDate, endDate] = values.operationDate;
      filtered = filtered.filter((order) => {
        const orderDate = dayjs(order.time);
        return orderDate.isBetween(startDate, endDate, 'null', '[]');
      });
    }

    // 用戶姓名篩選
    if (values.operator) {
      filtered = filtered.filter((order) => {
        const user = userInfo.find((u) => u.value === values.operator);
        return order.user.includes(user.label);
      });
    }

    // 操作類型篩選
    if (values.operationType) {
      filtered = filtered.filter((order) => {
        const typeMap = {
          0: '登入',
          1: '訂單搜尋',
          2: '客戶搜尋',
          3: '推播搜尋',
          4: '目標客群搜尋',
          5: '訂單數量搜尋',
          6: '訂單金額搜尋',
        };
        return order.type.includes(typeMap[values.operationType]);
      });
    }

    // 操作內容篩選
    if (values.operationContent) {
      filtered = filtered.filter((order) => {
        const contentMap = {
          0: '用戶登入系統',
          1: '用戶搜尋訂單資訊',
          2: '用戶搜尋客戶資訊',
          3: '用戶搜尋推播資訊',
          4: '用戶搜尋目標客群資訊',
          5: '用戶搜尋訂單數量資訊',
          6: '用戶搜尋訂單金額資訊',
        };
        return order.content.includes(contentMap[values.operationContent]);
      });
    }

    setLogData(filtered);
    setFilters(values);
    setFilterVisible(false);
    message.success(`篩選完成，共 ${filtered.length} 筆資料`);
  };

  return (
    <Modal
      title="進階篩選"
      open={filterVisible}
      onCancel={() => setFilterVisible(false)}
      width={800}
      footer={[
        <Button
          key="clear"
          onClick={() => {
            setFilters({});
            form.resetFields();
            fetchLogData();
          }}>
          清除所有
        </Button>,
        <Button key="cancel" onClick={() => setFilterVisible(false)}>
          取消
        </Button>,
        <Button
          key="search"
          type="primary"
          onClick={async () => {
            form.submit();
          }}>
          搜尋
        </Button>,
      ]}>
      <ModalForm
        handleAdvancedFilter={handleAdvancedFilter}
        form={form}
        filters={filters}
        userInfo={userInfo}
      />
    </Modal>
  );
};

// 搜尋Modal專用的Form
const ModalForm = (props) => {
  const { handleAdvancedFilter, form, filters, userInfo } = props;

  useEffect(() => {
    form.setFieldsValue(filters);
  }, [filters]);

  return (
    <Form form={form} layout="vertical" onFinish={handleAdvancedFilter}>
      <div style={{ marginBottom: 24 }}>
        <h4 style={{ marginBottom: 16, fontSize: 16, fontWeight: 'bold' }}>
          操作紀錄
        </h4>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="操作時間" name="operationDate">
              <RangePicker style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="操作類型" name="operationType">
              <Select placeholder="請選擇">
                <Select.Option value="0">登入</Select.Option>
                <Select.Option value="1">訂單搜尋</Select.Option>
                <Select.Option value="2">客戶搜尋</Select.Option>
                <Select.Option value="3">推播搜尋</Select.Option>
                <Select.Option value="4">目標客群搜尋</Select.Option>
                <Select.Option value="5">訂單數量搜尋</Select.Option>
                <Select.Option value="6">訂單金額搜尋</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="操作人員" name="operator">
              <Select placeholder="請選擇" options={userInfo} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="操作內容" name="operationContent">
              <Select placeholder="請選擇">
                <Select.Option value="0">用戶登入系統</Select.Option>
                <Select.Option value="1">用戶搜尋訂單資訊</Select.Option>
                <Select.Option value="2">用戶搜尋客戶資訊</Select.Option>
                <Select.Option value="3">用戶搜尋推播資訊</Select.Option>
                <Select.Option value="4">用戶搜尋目標客群資訊</Select.Option>
                <Select.Option value="5">用戶搜尋訂單數量資訊</Select.Option>
                <Select.Option value="6">用戶搜尋訂單金額資訊</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

// 驗證props
ExtraSearch.propTypes = {
  form: PropTypes.object,
  setFilters: PropTypes.func,
  filters: PropTypes.object,
  filterVisible: PropTypes.bool,
  setFilterVisible: PropTypes.func,
  setLogData: PropTypes.func,
  fetchLogData: PropTypes.func,
  userInfo: PropTypes.array,
  originLogData: PropTypes.array,
};

ModalForm.propTypes = {
  handleAdvancedFilter: PropTypes.func,
  form: PropTypes.object,
  filters: PropTypes.object,
  userInfo: PropTypes.array,
};

export default ExtraSearch;
